/**
 * Sukhara Collections — fade-in observer
 * Tiny IntersectionObserver-driven motion. Honors prefers-reduced-motion.
 * No dependencies. <1KB.
 */
(function () {
  'use strict';

  function init() {
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var nodes = document.querySelectorAll('.sk-fade-in');
    if (!nodes.length) return;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      // Reveal everything immediately as a graceful fallback.
      for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-visible');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.1
    });

    for (var j = 0; j < nodes.length; j++) io.observe(nodes[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when Shopify Theme Editor injects/updates a section.
  document.addEventListener('shopify:section:load', init);
})();